<!-- Main Row Container -->
<div class="row">
  <!-- Button Group and Add Button -->
  <div class="d-flex mt-3">
    <!-- Button Group for View Selection -->
    <div class="flex-grow-1 bd-highlight">
      <div class="btn-group pl-3 pt-1" role="group">
        <!-- Radio Button for All -->
        <input
          type="radio"
          class="btn-check border"
          (click)="filterPromotion('all')"
          name="btnradio"
          id="btnradio2"
          autocomplete="off"
          [checked]="statusFilter === 'all'"
        />
        <label class="btn btn-light pl-5 pr-5" for="btnradio2">All</label>

        <!-- Radio Button for Active -->
        <input
          type="radio"
          class="btn-check border"
          (click)="filterPromotion('active')"
          name="btnradio"
          id="btnradio1"
          autocomplete="off"
          [checked]="statusFilter === 'active'"
        />
        <label class="btn btn-light border-right pl-5 pr-5" for="btnradio1">Active</label>

        <!-- Radio Button for In Active -->
        <input
          type="radio"
          class="btn-check border"
          (click)="filterPromotion('in-active')"
          name="btnradio"
          id="btnradio3"
          autocomplete="off"
          [checked]="statusFilter === 'in-active'"
        />
        <label class="btn btn-light border-right pl-5 pr-5" for="btnradio3">InActive</label>

        <!-- Radio Button for Archived -->
        <input
          type="radio"
          class="btn-check border"
          (click)="filterPromotion('archived')"
          name="btnradio"
          id="btnradio4"
          autocomplete="off"
          [checked]="statusFilter === 'archived'"
        />
        <label class="btn btn-light border-right pl-5 pr-5" for="btnradio4">Archived</label>
      </div>
    </div>

    <!-- Add New Table Button -->
    <div class="bd-highlight pr-2">
      <button class="btn btn-dark add-btn" (click)="addNewPromotion()">+ New Promotion</button>
    </div>
  </div>
</div>

<div class="row mt-4 pl-2 pr-2">
  <div class="container">
    <table class="table text-center">
      <thead class="table-light">
        <tr class="bg-dark">
          <th scope="col">Name</th>
          <th scope="col">Scope</th>
          <th scope="col">Type</th>
          <th scope="col">Start</th>
          <th scope="col">End</th>
          <th scope="col">Active Days</th>
          <th scope="col">Applied to</th>
          <th scope="col">Discount/Offer</th>
          <th scope="col">Status</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (promotion of promotions; track promotion; let i = $index) {
          <tr class="border">
            <td>{{ promotion.name }}</td>
            <td>{{ promotion.scope }}</td>
            <td>{{ promotion.type }}</td>
            <td>{{ promotion.promotion_start_date }}</td>
            <td>{{ promotion.promotion_end_date }}</td>
            <td>
              @for (day of promotion.active_days; track day; let j = $index) {
                @if (day) {
                  <span class="badge bg-light text-dark rounded-5 px-2 py-1 me-1 mb-1">{{
                    day | titlecase
                  }}</span>
                }
              }
            </td>
            <td>
              @for (option of promotion.scope_options; track option; let j = $index) {
                @if (option.name) {
                  <span class="badge bg-light text-dark rounded-5 px-2 py-1 me-1 mb-1">{{
                    option.name
                  }}</span>
                }
              }
            </td>
            <td>
              @if (promotion.type == 'percentage') {
                {{ promotion.promotion_percentage }} %
              } @else {
                {{ promotion.promotion_price }} $
              }
            </td>
            <td>
              @if (promotion.is_active) {
                <button class="btn btn-success rounded-5 status-available border-0 m-auto pe-none">
                  <span class="available">Active</span>
                </button>
              } @else if (promotion.status == 'Scheduled') {
                <button class="btn btn-warning rounded-5 status-warning border-0 m-auto pe-none">
                  <span class="occupied">Scheduled</span>
                </button>
              } @else if (!promotion.is_active && !promotion.is_deleted) {
                <button class="btn btn-danger rounded-5 status-danger border-0 m-auto pe-none">
                  <span class="reserved">InActive</span>
                </button>
              } @else if (promotion.is_deleted) {
                <button class="btn btn-warning rounded-5 status-warning border-0 m-auto pe-none">
                  <span class="reserved">Archived</span>
                </button>
              }
            </td>
            <td class="overflow-visible">
              <div class="btn-group custom-dropdown1">
                <button
                  type="button"
                  class="btn bg-white dropdown-toggle pl-1 pr-1"
                  data-bs-toggle="dropdown"
                  data-bs-display="static"
                  aria-expanded="false"
                >
                  <i class="bx bx-dots-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-lg-end">
                  <li (click)="addNewPromotion(promotion)">
                    <a class="dropdown-item type-option">
                      <i class="bx bx-edit mr-3"></i> Edit Promo
                    </a>
                  </li>
                  @if (!promotion.is_deleted) {
                    <li>
                      <a class="dropdown-item type-option">
                        <i class="bx bx-lock mr-3"></i> Disable Promo
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item type-option">
                        <i class="bx bx-trash mr-3"></i> Delete Promo
                      </a>
                    </li>
                  }
                </ul>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
